
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nfts",
      function () {
        return require("private-next-pages/nfts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nfts"])
      });
    }
  